export default __webpack_public_path__ + "static/media/frame_overlay_far_red.64f868db.png";